import type { Type } from '@angular/core';
import type { DefaultExport } from '@angular/router';

export type LazyComponent = Type<unknown> | DefaultExport<Type<unknown>>;
export type LazyComponentLoader = () => Promise<LazyComponent>;

export const followUpLoaders: Record<number, LazyComponentLoader> = {
  1: () =>
    import('../question1-follow-up/question1-follow-up').then(module => module.Question1FollowUp),
  2: () =>
    import('../question2-follow-up/question2-follow-up').then(module => module.Question2FollowUp),
  3: () =>
    import('../question3-follow-up/question3-follow-up').then(module => module.Question3FollowUp),
  4: () =>
    import('../question4-follow-up/question4-follow-up').then(module => module.Question4FollowUp),
  5: () =>
    import('../question5-follow-up/question5-follow-up').then(module => module.Question5FollowUp),
  6: () =>
    import('../question6-follow-up/question6-follow-up').then(module => module.Question6FollowUp),
  7: () =>
    import('../question7-follow-up/question7-follow-up').then(module => module.Question7FollowUp),
  8: () =>
    import('../question8-follow-up/question8-follow-up').then(module => module.Question8FollowUp),
  9: () =>
    import('../question9-follow-up/question9-follow-up').then(module => module.Question9FollowUp),
  10: () =>
    import('../question10-follow-up/question10-follow-up').then(
      module => module.Question10FollowUp,
    ),
  11: () =>
    import('../question11-follow-up/question11-follow-up').then(
      module => module.Question11FollowUp,
    ),
  12: () =>
    import('../question12-follow-up/question12-follow-up').then(
      module => module.Question12FollowUp,
    ),
  13: () =>
    import('../question13-follow-up/question13-follow-up').then(
      module => module.Question13FollowUp,
    ),
};

export const thankYouLoader: LazyComponentLoader = () =>
  import('../thank-you-page/thank-you-page').then(module => module.ThankYouPage);
